import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../reducers';

const action = _name => () => {}; // eslint-disable-line no-unused-vars

export const mockState = {
  sinatra: {
    irp: {
      queryURI: 'test_uri',
      irp_access_token: 'test_token',
      irpVersion: '1',
    },
    user: {
      currentRole: {
        permissions: ['ALERTS'],
      },
      currentOrg: {
        name: 'DEMO',
      },
      profile: {
        organizations: [
          {
            name: 'DEMO',
            roles: [],
            attributes: {
              audio_settings: {
                calls: {
                  sound_on: true,
                  tone: 'xyloToggle',
                },
                alerts: {
                  sound_on: true,
                  tone: 'glassVibes',
                  repeat: true,
                },
                sms: {
                  sound_on: true,
                  tone: 'tripleVibe',
                },
              },
            },
          },
        ],
      },
    },
  },
  psaps: {
    currentPSAP: {
      activeCapabilities: [],
    },
  },
  keywordTiers: {
    loading: false,
    loadingError: null,
    saving: false,
    savingError: null,
    keywordTiers: [
      { id: 'tier-1', name: 'Tier 1', notifications: true },
      { id: 'tier-2', name: 'Tier 2', notifications: true },
      { id: 'tier-3', name: 'Tier 3', notifications: true },
    ],
  },
};

export const mockStore = {
  getState: () => {
    return mockState;
  },
  subscribe: () => 0,
  dispatch: action('dispatch'),
};

export const mockStoreFactory = () =>
  configureStore({
    reducer: rootReducer,
    preloadedState: mockState,
  });

export const mockOrgSettings = {
  alerts: {
    sound_on: true,
    tone: 'glassVibes',
    repeat: true,
  },
  calls: {
    sound_on: true,
    tone: 'xyloToggle',
  },
  tt911: {
    sound_on: true,
    tone: 'tripleVibe',
    repeat: true,
    repeat_times: 2,
  },
  sms: {
    sound_on: true,
    tone: 'tripleVibe',
  },
};

export const mockAlertToastsSettings = {
  alert_types: {
    alerts_active_assailant: {
      display_name: 'Active Assailant Alerts',
      name: 'alerts_active_assailant',
      enabled: true,
    },
    alerts_train_incident: {
      display_name: 'Train Incident Alerts',
      name: 'alerts_train_incident',
      enabled: true,
    },
    alerts_law_enforcement: {
      display_name: 'Law Enforcement Alerts',
      name: 'alerts_law_enforcement',
      enabled: true,
    },
    alerts_medical: {
      display_name: 'Medical alerts',
      name: 'alerts_medical',
      enabled: true,
    },
    alerts_test_mode: {
      display_name: 'Test Alerts',
      name: 'alerts_test_mode',
      enabled: true,
    },
    alerts_fire: {
      display_name: 'Fire Alerts',
      name: 'alerts_fire',
      enabled: true,
    },
  },
};
